// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cE-r","questions":"styles_questions__323A6","footer":"styles_footer__3NwTH"};